/* eslint-disable import/prefer-default-export */
import styled, { keyframes } from 'styled-components';

const shake = keyframes`
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
`;
export const SkipLink = styled.a`
  position: fixed;
  top: 8px;
  left: 8px;
  z-index: 10000;
  padding: 8px 16px;
  background: ${(props) => props.theme.colorStyled.ColorWhite};
  color: ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
  border: 2px solid ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
  border-radius: 4px;
  font-family: 'MontserratMedium', sans-serif;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  opacity: 0;
  pointer-events: none;
  &:focus {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const PracticeMain = styled.div`
  flex: 1;
  min-width: 0;
  outline: none;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

export const GroupSheetContainer = styled.div`
  width: 100%;
  transition: all 300ms ease;
  position: relative;
  height: 100vh;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
  /* shake transition */
  & .shake {
    animation: ${shake} 0.5s;
  }
`;
